<div class="page" *ngIf="apiName">
  <div class="statebox">
    <ssg-select
      [label]="'ClientApp.FrontOffice.Order.Invoices.InvoiceStatus' | translate"
      name="invoiceFilter"
      [group]="formGroup"
      userClass="select-sm"
      dropdownPosition="auto"
      (valueChange)="setFilter($event)"
      (valueClear)="invoiceFilterClear()"
      [dataList]="invoiceFilter"
      textFieldName="title"
      valueFieldName="key">
    </ssg-select>
    <ssg-select
      *ngIf="!order.common.isMobileMode && order.currentInformation?.OrderServices && order.saleMethodBranch?.HasDeposit"
      name="MealTime"
      [label]="'ClientApp.FrontOffice.Order.Invoices.Meal' | translate"
      [group]="formGroup"
      [multiple]="true"
      [dataList]="MealTimeDataList"
      textFieldName="Title"
      valueFieldName="Id"
      userClass="select-sm"
      (valueChange)="onMealTimeChanged($event)">
    </ssg-select>
    <ssg-select
      *ngIf="!order.common.isMobileMode && order.isMultiBranch && order.currentSaleMethodNature === order.SaleMethodNature.Delivery"
      [label]="'General.Branch' | translate"
      name="branchFilter"
      [group]="formGroup"
      [multiple]="true"
      dropdownPosition="auto"
      limitSelection="5"
      userClass="select-md"
      [hasSelectAll]="true"
      (valueChange)="onBranchFilterChanged($event)"
      (valueClear)="onBranchFilterClear()"
      [dataList]="allBranchesExceptCallCenter"
      textFieldName="Title"
      valueFieldName="Id">
    </ssg-select>
    <ssg-button
      *ngIf="
        order.currentInformation?.PaymentPanelAVA &&
        order.saleMethodBranch?.IsPaymentLink &&
        (order.saleMethodBranch?.HasPaymentLink || order.saleMethodBranch?.HasFactorLink) &&
        order.common.smartConnection &&
        order.currentSaleMethodNature !== order.SaleMethodNature.FastFood
      "
      class="statebtn"
      [label]="'ClientApp.FrontOffice.Order.Invoices.ResendLink' | translate"
      (click)="retryLink()"></ssg-button>

    <ssg-button
      *ngIf="!order.common.isMobileMode && order.currentInformation?.OrderServices && order.saleMethodBranch?.HasDeposit"
      class="statebtn"
      [label]="'ClientApp.FrontOffice.Order.Invoices.OrderService' | translate"
      (click)="showDepositDateFilter()"
      [class.selected-item]="depositFilterIsSelected"></ssg-button>

    <ssg-button
      *ngIf="!order.common.isMobileMode && order.currentInformation?.OrderServices && order.saleMethodBranch?.HasDeposit && depositFilterIsSelected"
      class="statebtn"
      (click)="pritFactors()"
      [label]="'ClientApp.FrontOffice.Order.Invoices.PrintOrders' | translate"></ssg-button>
  </div>
  <div class="header" [class.mobile-mode]="order.common.isMobileMode" *ngIf="onFilter && apiName != undefined">
    <kgrid
      #invoiceGrid
      [areaName]="areaName"
      [noAutoFitColumns]="true"
      [label]="label"
      [isAdd]="false"
      [apiName]="apiName"
      [showLoadingMessage]="false"
      [isEdit]="true"
      [hasReport]="false"
      [editFromForm]="true"
      [name]="apiName"
      pagingSize="10"
      pathPreFix="SALE"
      [VoucherKindId]="currentSaleMethodBranch?.Id"
      [columns]="columns"
      [groupable]="false"
      [unSortableFilterable]="unSortableFilterable"
      defaultSortKey="Code"
      (onEdit)="onDoubleClick($event)"
      [disableOnDoubleClick]="true"
      (onDoubleClick)="onDoubleClick($event)"
      (onRowSelected)="onRowSelected($event)"
      (onDeleteCompleted)="deleteInvoiceExtra($event)"
      [actions]="actions"
      [isMulti]="false"
      [actionTregger]="onActionClick"
      [filters]="onFilter"
      [customExportExcelUrl]="'Invoice/ExportExcel'"
      [getParamsForExportExcelWithPostMethod]="getParamsForExportExcelWithPostMethod.bind(this)"
      [gridName]="'ClientApp.FrontOffice.Order.OrderPage.Header.Factors' | translate"
      class="gridheader">
    </kgrid>
  </div>
  <div class="detail" *ngIf="!this.order.common.isMobileMode">
    <kgrid
      #itemGrid
      *ngIf="InvoiceItemColumns && InvoiceItemColumns?.length > 0"
      class="griddetail"
      [label]="label"
      [noAutoFitColumns]="true"
      [isAdd]="false"
      [isEdit]="false"
      [isDelete]="false"
      [groupable]="false"
      [noToolBar]="true"
      [hideToolber]="true"
      [name]="InvoiceItems"
      [showLoadingMessage]="false"
      pathPreFix="SALE"
      [filtering]="false"
      [columns]="InvoiceItemColumns"
      [dataList]="InvoiceItems"
      [IgnoreDeletePermission]="IgnoreDeletePermission"
      [isMulti]="false">
    </kgrid>
  </div>
</div>
